var Backbone = require('backbone');
var Marionette = require('marionette');
var Dialog = require('Dialog');
var Labels = EY.Consultation.Labels;

var Warning = Marionette.View.extend({
    template: '#dialogWarning'
});

module.exports.show = function (options) {
    var message = options.message;

    return Dialog.show({
        headerLabel: Labels.DialogTitleWarning,
        saveLabel: Labels.OK,
        view: new Warning({ model: new Backbone.Model({ message: message }) })
    });
};


// WEBPACK FOOTER //
// ./js/Modules/Dialog/DialogWarning.js